import { Avatar, IconButton, Tooltip } from '@material-ui/core';
import { IconChevronRight, IconQuestionMark, IconStar } from '@tabler/icons';
import { formatDistanceStrict } from 'date-fns';
import { es } from 'date-fns/locale';
import clsx from 'clsx';

import { useDialog } from '#root/hooks';
import { GuveryShippingBadge } from '#root/ui-components';
import { Badge, Card, PricePair } from '#root/components/ui';
import { PersonIcon } from '#root/icons';
import { ImageHorizontal } from '#root/assets';
import * as VARIABLES from '#root/constants/variables';
import OrderPriceDialog from '../../OrderPriceDialog';
import styles from './orderInfo.module.scss';

const getTime = (orderDate) => {
  let time;
  try {
    time = orderDate
      ? formatDistanceStrict(new Date(orderDate.replace(/ /g, 'T')), new Date(), { locale: es })
      : '---';
  } catch (error) {
    time = 'error';
  }
  return time;
};

const OrderInfo = (props) => {
  const { order } = props;
  const priceDialog = useDialog();
  const orderDate = order?.fecpub ? order?.fecpub : order?.feccre;
  const formatDate = getTime(orderDate);

  return (
    <Card flat noBorder noHover className={styles.root}>
      <div className={styles.top}>
        <div className={styles.cover}>
          <a
            className="guv-no-decoration"
            href={order?.url}
            target="_blank"
            rel="noopener noreferrer">
            {order?.img_path ? (
              <img className={clsx(styles.image)} src={order.img_path} alt="Pedido" />
            ) : (
              <img
                className={clsx(styles.image, styles.placeholder)}
                src={ImageHorizontal}
                alt="Pedido"
              />
            )}
          </a>

        </div>
        <div className={styles.content}>
          <div className={styles.contentWrap}>
            <div>
              <div className={styles.header}>
                <span className={styles.date}>Hace {formatDate}</span>
                {order.flag_envio === 1 && (
                  <Badge
                    variant="shipping"
                    size="sm"
                  >
                    Envío Nacional
                  </Badge>
                )}
              </div>

              <a
                className="guv-no-decoration guv-block"
                href={order?.url}
                target="_blank"
                rel="noopener noreferrer">
                <h3 className={styles.title}>{order?.tit}</h3>
              </a>

              <div className={styles.badges}>
                <a
                  className={styles.badge}
                  href={order?.url}
                  target="_blank"
                  rel="noopener noreferrer">
                  {order?.url_host}
                </a>
                {order?.can && order?.can > 1 && (
                  <span className={`${styles.badge} ${styles.quantity}`}>x {order?.can}</span>
                )}
                {order?.condicion && (
                  <span className={styles.badge}>condición: {order?.condicion}</span>
                )}
                {order?.empaque && <span className={styles.badge}>{order?.empaque}</span>}
              </div>

              {order?.obs && <p className={styles.obs}>{order.obs}</p>}
            </div>
            <a
              className="guv-no-decoration guv-block"
              href={order?.url}
              target="_blank"
              rel="noopener noreferrer">
              <div className={styles.shop}>
                <h5 className={styles.shopTitle}>
                  <span>{order?.url_host}</span>
                </h5>
                <div className={styles.shopInfo}>
                  <IconButton size="small" color="primary" className={styles.link}>
                    <IconChevronRight />
                  </IconButton>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className={styles.actions}>
        <div className={styles.actionsWrap}>
          {order?.user && (
            <div className={styles.avatar}>
              <Avatar
                alt={order.user?.mask_fullname}
                src={VARIABLES.IMAGE_PROFILE_PATH + order.user?.pic + '.png'}
                sizes="24">
                <PersonIcon />
              </Avatar>
              <div>
                <span className={styles.name}>{order.user?.mask_fullname}</span>
                {order?.user?.calcom && (
                  <Tooltip arrow title="Puntaje del comprador" placement="bottom">
                    <div className={styles.userScore}>
                      <IconStar />
                      <span>{order.user.calcom}</span>
                    </div>
                  </Tooltip>
                )}
              </div>
            </div>
          )}
          {/* Precio ref. + comisión prop.: el mismo sub-card que en la lista de pedidos */}
          <PricePair
            className={styles.pricePair}
            priceLabel="Precio ref."
            price={order?.pre}
            commissionLabel="Comisión prop."
            commission={order?.com}
            aria-label="Ver qué son el precio referencial y la comisión propuesta"
            onClick={priceDialog.openDialog}
          />
        </div>
      </div>
      <OrderPriceDialog open={priceDialog.open} onClose={priceDialog.closeDialog} order={order} />
    </Card>
  );
};

export default OrderInfo;
